import { BASE_URL } from "../Config/baseUrl";

export const COUNTRIES = BASE_URL + 'countries'